import { connectToBackend, GenesysLoadStatus } from "../api/backendConnector";
import ICoBrowseDto from "../interface/ICoBrowseDto";
import IMessage from "../interface/IMessage";
import { CoBrowseContext } from "../store/coBrowse.context";
import { AppContext } from "../store/genesys.context";
import React from "react";

const useBackendApi = () => {
  const {
    setBotIsTyping,
    updateMessageList,
    getDeploymentId,
  }: {
    setBotIsTyping: React.Dispatch<React.SetStateAction<boolean>>;
    updateMessageList: (message: IMessage, saveToLocalStorage: boolean) => void;
    getDeploymentId: () => string;
  } = React.useContext(AppContext);

  const {
    setCoBrowseDto,
  }: {
    setCoBrowseDto: React.Dispatch<React.SetStateAction<ICoBrowseDto>>;
  } = React.useContext(CoBrowseContext);

  // Keep a ref to the latest updateMessageList so the callback captured by
  // connectToBackend never goes stale when the function reference changes.
  const updateMessageListRef = React.useRef(updateMessageList);
  React.useEffect(() => {
    updateMessageListRef.current = updateMessageList;
  });

  const stableUpdateMessageList = React.useCallback(
    (message: IMessage, saveToLocalStorage: boolean) =>
      updateMessageListRef.current(message, saveToLocalStorage),
    [],
  );

  const connect = async (onStatus?: (status: GenesysLoadStatus) => void) =>
    await connectToBackend(
      setBotIsTyping,
      setCoBrowseDto,
      stableUpdateMessageList,
      getDeploymentId,
      onStatus,
    );

  return { connect };
};

export default useBackendApi;
